export default {
  'pages.applicationCatalog.openDirectory': '应用管理',
  'pages.applicationCatalog.title': '业务应用',
  'pages.applicationCatalog.selectAppHint': '从左侧选择应用查看详情',
  'pages.applicationCatalog.backToCenter': '返回应用',
  'pages.applicationCatalog.create': '新建应用',
  'pages.applicationCatalog.edit': '编辑应用',
  'pages.applicationCatalog.refresh': '刷新',
  'pages.applicationCatalog.details': '详情',
  'pages.applicationCatalog.resources': '资源管理',
  'pages.applicationCatalog.delete': '删除应用',
  'pages.applicationCatalog.more': '更多',
  'pages.applicationCatalog.moreForApp': '更多操作：{name}',
  'pages.applicationCatalog.deleteTitle': '确认从全平台删除应用「{name}」？',
  'pages.applicationCatalog.deleteDescription':
    '将删除共享 IAM 应用及本地扩展信息，影响所有使用该应用的企业。此操作不可恢复，也不是取消当前企业开通。',
  'pages.applicationCatalog.deleteConfirm': '从全平台删除',
  'pages.applicationCatalog.cancel': '取消',
};
